import React from 'react'
import { Mutation } from "react-apollo";
import Form from "../components/form";
import { EDIT, GET } from "../../../queries/user";
import { ADD_EDIT_ACCESS, GET_BY_USER } from "../../../queries/access";
import { ADD_EDIT_NETWORK_USER_ACCESS, GET_NETWORK_BY_USER } from "../../../queries/userNetworks";
import { Query } from "react-apollo";

const Update = (props) => {
  return (
    <>
    <Mutation
      mutation={EDIT}
      update={(cache, { data: { updateUser } }) => {
        const { users } = cache.readQuery({ query: GET });
        cache.writeQuery({
          query: GET,
          data: { users: users }
        });
      }}
      >
      {updateUser => (
        <Mutation mutation={ADD_EDIT_ACCESS} update={(store, { data: { createAccess } }) => {}}>
        {createAccess=> (
          <Mutation mutation={ADD_EDIT_NETWORK_USER_ACCESS} update={(store, { data: { createUserNetwork } }) => {}}>
          {createUserNetwork=> (
          <Query query={GET_BY_USER} variables={{ user: props.id }}>
          {({ loading, error, data }) => {
            if (loading) return "Loading...";
            if (error) return `Error! ${error.message}`;
            let sites = [];
            data.accesses.forEach(access => {
              sites.push(access.site.id);
            });
            return (
              <Query query={GET_NETWORK_BY_USER} variables={{ user: props.id }}>
              {({ loading, error, data }) => {
                if (loading) return "Loading...";
                if (error) return `Error! ${error.message}`;
                let networks = [];
                data.userNetworks.forEach(userNetwork => {
                  networks.push(userNetwork.network.id);
                });
                return (
                <Form query_f = {updateUser} query_access={createAccess} query_userNetworks={createUserNetwork} sites={sites} networks={networks} {...props} />
                );
              }}
            </Query>
            );
          }}
        </Query>
        )}
        </Mutation>
      )}
      </Mutation>
    )}
    </Mutation>
    
    </>
  );
};

export default Update;